import { RequestStatus } from 'features/common'
import { MapType } from 'features/maps/types'
import { ProviderType } from 'features/connections'
import { IntersectAnalysisSettings } from './ui/NewAnalysisDialog/AnalysisCatalog/IntersectAndAggregate/types'
import { FilterByColumnSettings } from './ui/NewAnalysisDialog/AnalysisCatalog/FilterByColumn/types'
import { BufferSettings } from './ui/NewAnalysisDialog/AnalysisCatalog/Buffer/types'
import { ColumnsFromSourceSettings } from './ui/NewAnalysisDialog/AnalysisCatalog/ColumnsFromSource/types'
import { ClusteringKMeansSettings } from './ui/NewAnalysisDialog/AnalysisCatalog/ClusteringKMeans/types'
import { CentroidSettings } from './ui/NewAnalysisDialog/AnalysisCatalog/Centroid/types'

export const VALID_NUMERIC_TYPES = [
  'int',
  'smallint',
  'integer',
  'bigint',
  'tinyint',
  'byteint',
  'int64',
  'decimal',
  'numeric',
  'float64',
  'float',
  'number',
  'real'
]

export enum AnalysisType {
  Intersect = 'intersect',
  AddColumn = 'addColumn',
  Geocode = 'geocode',
  Buffer = 'buffer',
  Geocode2 = 'geocode2',
  AddColumn2 = 'addColumn2',
  ColumnValue = 'columnValue',
  CreateTable = 'createTable',
  ClusteringKMeans = 'clusteringKMeans',
  Centroid = 'centroid',
  TradeAreas = 'tradeAreas'
}

export enum OperationType {
  AVG = 'avg',
  SUM = 'sum',
  MAX = 'max',
  MIN = 'min',
  COUNT = 'count'
}

export const Operations = {
  [OperationType.AVG]: {
    instruction: 'avg',
    supportedTypes: VALID_NUMERIC_TYPES
  },
  [OperationType.COUNT]: {
    instruction: 'count'
  },
  [OperationType.SUM]: {
    instruction: 'sum',
    supportedTypes: VALID_NUMERIC_TYPES
  },
  [OperationType.MAX]: {
    instruction: 'max',
    supportedTypes: VALID_NUMERIC_TYPES
  },
  [OperationType.MIN]: {
    instruction: 'min',
    supportedTypes: VALID_NUMERIC_TYPES
  }
}

export interface Analysis {
  id: string
  output: string
  type: MapType.table | MapType.query
  analysisType: AnalysisType
  provider: ProviderType
  status: RequestStatus
  error?: string
}

export interface AnalysisMetadata {
  output: string
  connection: string
  mapId: string
  type: MapType
  analysisType: AnalysisType
  provider: ProviderType
}

export interface AnalysisSettings {
  mainSource: string
  analysisType?: AnalysisType
}

export enum AnalysisSteps {
  Analysis,
  Settings,
  Destination,
  Confirmation
}

export type AnalysisSourceFooter = {
  title: string
  description: string
  linkText: string
  link: string
}

export type SettingsSnapshot =
  | CentroidSettings
  | IntersectAnalysisSettings
  | FilterByColumnSettings
  | BufferSettings
  | ColumnsFromSourceSettings
  | ClusteringKMeansSettings
